module.exports = __webpack_public_path__ + "img/resources-375.04f2090a.jpg";